import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, TrendingUp, Users, Zap, Shield } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { HOME_LINKS } from "../../config/homeLinks";

export function TradingGroupLandingPage() {
  const navigate = useNavigate();

  return (
    <div className="h-full flex flex-col bg-[#0a0f20] text-white overflow-hidden">
      {/* Header */}
      <div className="flex items-center px-4 py-2 border-b border-border/30 shrink-0">
        <button
          onClick={() => navigate("/profile")}
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-white transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Kembali ke Profile
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-start px-4 pt-6 pb-4 text-center min-h-0 overflow-y-auto">
        <div className="max-w-3xl w-full flex flex-col items-center">
          {/* Title */}
          <h1 className="text-4xl sm:text-5xl font-bold leading-tight mb-3">
            Join Trading Community
            <br />
            <span className="text-red-500">BandarmoloNY</span> with Nic Yansen
          </h1>

          {/* Description */}
          <p className="text-muted-foreground text-sm max-w-lg mb-3 leading-relaxed">
            Dapatkan rekomendasi saham menarik dan trading bareng bersama komunitas setiap hari.
            Dipandu langsung oleh Nic Yansen, analis berpengalaman yang fokus membaca pergerakan bandar.
          </p>

          {/* FREE badge */}
          <div className="inline-flex items-center gap-1.5 bg-green-500/15 text-green-400 text-xs font-bold px-3 py-1 rounded-full mb-4">
            <Zap className="h-3 w-3" />
            GRATIS!
          </div>

          {/* Benefit cards */}
          <div className="grid grid-cols-3 gap-2 mb-5 w-full">
            <Card className="bg-card/50 border-border/30">
              <CardContent className="p-3 text-center">
                <TrendingUp className="h-5 w-5 text-red-500 mx-auto mb-1" />
                <h3 className="text-xs font-semibold mb-0.5">Rekomendasi Harian</h3>
                <p className="text-[10px] text-muted-foreground">Saham menarik berdasarkan analisis bandarmologi</p>
              </CardContent>
            </Card>
            <Card className="bg-card/50 border-border/30">
              <CardContent className="p-3 text-center">
                <Users className="h-5 w-5 text-red-500 mx-auto mb-1" />
                <h3 className="text-xs font-semibold mb-0.5">Trading Bareng</h3>
                <p className="text-[10px] text-muted-foreground">Diskusi dan eksekusi bersama komunitas aktif</p>
              </CardContent>
            </Card>
            <Card className="bg-card/50 border-border/30">
              <CardContent className="p-3 text-center">
                <Shield className="h-5 w-5 text-red-500 mx-auto mb-1" />
                <h3 className="text-xs font-semibold mb-0.5">Dipandu Mentor</h3>
                <p className="text-[10px] text-muted-foreground">Bimbingan langsung dari Nic Yansen</p>
              </CardContent>
            </Card>
          </div>

          {/* How to join */}
          <div className="bg-card/30 border border-border/30 rounded-xl p-4 w-full max-w-lg">
            <h2 className="text-base font-bold mb-1">Cara Bergabung</h2>
            <p className="text-xs text-muted-foreground mb-2">
              Buka akun di sekuritas partner kami untuk akses gratis ke komunitas trading.
            </p>

            <div className="flex items-center justify-center gap-1 text-xs text-muted-foreground mb-3">
              <span>Min. Deposit</span>
              <span className="text-white font-bold text-sm">Rp. 200 jt</span>
            </div>

            <div className="grid grid-cols-2 gap-2 max-w-xs mx-auto">
              <Button
                size="sm"
                className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold"
                onClick={() => window.open(HOME_LINKS.valburyOpenAccount, "_blank", "noopener,noreferrer")}
              >
                <span className="font-bold tracking-tight" style={{ fontFamily: 'Arial, sans-serif', color: '#3d2e00' }}>KB Valbury</span>
                <ArrowUpRight className="h-3.5 w-3.5 ml-1" />
              </Button>
              <Button
                size="sm"
                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold"
                onClick={() => window.open(HOME_LINKS.sucorOpenAccount, "_blank", "noopener,noreferrer")}
              >
                <span className="font-bold tracking-tight" style={{ fontFamily: 'Arial, sans-serif' }}>Sucor</span>
                <ArrowUpRight className="h-3.5 w-3.5 ml-1" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
